<template>
  <tr
    v-if="bluredOrNotHidden"
    :class="{ active: isActive, hovered: showActions }"
    class="draggableBlock"
    data-block="GIF"
    tabindex="0"
    @mouseover="mouseOver"
    @mouseleave="mouseOut"
    @click.stop="() => click()"
  >
    <td
      :class="{
        'block-borders': showDragBorder,
        'dragged-opacity': isCurrentElementDragged,
      }"
      :style="{ padding: padding }"
      style="word-break: break-word; font-size: 0px"
      :align="align"
    >
      <blockActions
        v-if="showActions"
        :column-padding-x="columnPaddingX"
        :column-width="columnWidth"
        :disable-up-movement="disableUpMovement"
        :disable-down-movement="disableDownMovement"
        :is-active="isActive"
        :block-height="blockHeight"
        :block-width="blockWidth"
        :is-last-column="isLastColumn"
        :section-index="sectionIndex"
        :column-index="columnIndex"
        :block-index="blockIndex"
        :show-paste="showPaste"
        :copied="copied"
        @duplicate="copyBlock"
        @remove="deleteBlock"
        @moveUp="moveUp"
        @moveDown="moveDown"
        @copy="copyToClipboard"
      ></blockActions>
      <table
        role="presentation"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse: collapse; border-spacing: 0px"
        :align="align"
        border="0"
      >
        <tbody>
          <tr>
            <td
              v-if="isValidSrc"
              :style="{ width: widthWithFluidOnMobile, ...hiddenStyle }"
            >
              <a>
                <img
                  :id="id"
                  :alt="alt"
                  title=""
                  height="auto"
                  :src="src"
                  :style="imgStyle"
                  :width="width.replace('px', '')"
                />
              </a>
            </td>
            <td v-else :style="{ width: mjmlStore.getBodyWidth + 'px' }">
              <div class="placeholder-container">
                <div>
                  <svg
                    class="img-1"
                    width="40"
                    height="32"
                    viewBox="0 0 40 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.44444 1H35.5556C37.4288 1 39 2.57249 39 4.57143V27.4286C39 29.428 37.4318 31 35.5556 31H4.44444C2.56824 31 1 29.428 1 27.4286V4.57143C1 2.57197 2.56824 1 4.44444 1Z"
                      stroke="#6DA8FF"
                      stroke-width="2"
                    />
                    <path
                      d="M18.0553 19.6357C18.0553 20.0141 17.9089 20.3779 17.6485 20.6457C16.4581 21.8714 14.7498 22.5714 12.9512 22.5714C11.1567 22.5714 9.44562 21.8694 8.25742 20.6464C7.05534 19.4072 6.38867 17.7572 6.38867 16C6.38867 14.2429 7.05381 12.595 8.2602 11.3536C10.6734 8.8693 14.7998 8.87145 17.2116 11.3536C17.7541 11.9116 17.7541 12.8164 17.2116 13.3736C16.668 13.9316 15.7894 13.9316 15.2477 13.3736C13.8824 11.9686 11.5866 11.9686 10.2227 13.3736C9.54145 14.0786 9.16645 15.0072 9.16645 16C9.16645 16.9929 9.54187 17.9243 10.2241 18.6264C11.4442 19.8786 13.854 20.0286 15.2776 18.9786V18H12.6942C11.9269 18 11.3053 17.3605 11.3053 16.5714C11.3053 15.7824 11.9271 15.1429 12.6942 15.1429H16.6665C17.4338 15.1429 18.0553 15.7824 18.0553 16.5714V19.6357ZM22.4998 21.1429C22.4998 21.9322 21.878 22.5714 21.1109 22.5714C20.3437 22.5714 19.722 21.9319 19.722 21.1429V10.8572C19.722 10.0679 20.3437 9.42859 21.1109 9.42859C21.878 9.42859 22.4998 10.0681 22.4998 10.8572V21.1429ZM32.222 12.2857H27.4998V14.5714H31.1109C31.8783 14.5714 32.4998 15.2109 32.4998 16C32.4998 16.7891 31.8748 17.4286 31.1109 17.4286H27.4998V21.1429C27.4998 21.9322 26.878 22.5714 26.1109 22.5714C25.3437 22.5714 24.722 21.9319 24.722 21.1429V10.8572C24.722 10.0679 25.3437 9.42859 26.1109 9.42859H32.222C32.9894 9.42859 33.6109 10.0681 33.6109 10.8572C33.6109 11.6462 32.9859 12.2857 32.222 12.2857Z"
                      fill="#6DA8FF"
                    />
                  </svg>

                  <svg
                    class="img-2"
                    width="40"
                    height="32"
                    viewBox="0 0 44 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M37.5556 2H6.44444C3.98958 2 2 4.04643 2 6.57143V29.4286C2 31.9536 3.98958 34 6.44444 34H37.5556C40.0104 34 42 31.9536 42 29.4286V6.57143C42 4.04643 40.0069 2 37.5556 2Z"
                      fill="#6DA8FF"
                    />
                    <path
                      d="M37.5556 1H6.44444C3.41093 1 1 3.52089 1 6.57143V29.4286C1 32.4791 3.41093 35 6.44444 35H37.5556C40.5891 35 43 32.4791 43 29.4286V6.57143C43 3.52037 40.5851 1 37.5556 1Z"
                      stroke="white"
                      stroke-opacity="0.4"
                      stroke-width="2"
                    />
                    <path
                      d="M20.0553 21.6357C20.0553 22.0141 19.9089 22.3779 19.6485 22.6457C18.4581 23.8714 16.7498 24.5714 14.9512 24.5714C13.1567 24.5714 11.4456 23.8694 10.2574 22.6464C9.05534 21.4072 8.38867 19.7572 8.38867 18C8.38867 16.2429 9.05381 14.595 10.2602 13.3536C12.6734 10.8693 16.7998 10.8714 19.2116 13.3536C19.7541 13.9116 19.7541 14.8164 19.2116 15.3736C18.668 15.9316 17.7894 15.9316 17.2477 15.3736C15.8824 13.9686 13.5866 13.9686 12.2227 15.3736C11.5415 16.0786 11.1664 17.0072 11.1664 18C11.1664 18.9929 11.5419 19.9243 12.2241 20.6264C13.4442 21.8786 15.854 22.0286 17.2776 20.9786V20H14.6942C13.9269 20 13.3053 19.3605 13.3053 18.5714C13.3053 17.7824 13.9271 17.1429 14.6942 17.1429H18.6665C19.4338 17.1429 20.0553 17.7824 20.0553 18.5714V21.6357ZM24.4998 23.1429C24.4998 23.9322 23.878 24.5714 23.1109 24.5714C22.3437 24.5714 21.722 23.9319 21.722 23.1429V12.8572C21.722 12.0679 22.3437 11.4286 23.1109 11.4286C23.878 11.4286 24.4998 12.0681 24.4998 12.8572V23.1429ZM34.222 14.2857H29.4998V16.5714H33.1109C33.8783 16.5714 34.4998 17.2109 34.4998 18C34.4998 18.7891 33.8748 19.4286 33.1109 19.4286H29.4998V23.1429C29.4998 23.9322 28.878 24.5714 28.1109 24.5714C27.3437 24.5714 26.722 23.9319 26.722 23.1429V12.8572C26.722 12.0679 27.3437 11.4286 28.1109 11.4286H34.222C34.9894 11.4286 35.6109 12.0681 35.6109 12.8572C35.6109 13.6462 34.9859 14.2857 34.222 14.2857Z"
                      fill="white"
                    />
                  </svg>

                  <div class="placeholder-container__text">
                    {{ $t("mjml.animated_gif") }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import blockProperties from "@/composables/useBlockProperties";
  import blockActions from "./blockActions.vue";
  import { TopolBlock } from "@/schemas/templateSchema";

  import { StyleValue, computed, ref, watch, onMounted } from "vue";
  import { useMjmlStore } from "@/stores/mjmlStore";

  const mjmlStore = useMjmlStore();

  const props = defineProps<{
    block: TopolBlock;
    columnIndex: number;
    sectionIndex: number;
    blockIndex: number;
    isLocked: boolean;
  }>();

  const {
    showActions,
    showPaste,
    blockHeight,
    blockWidth,
    id,
    bluredOrNotHidden,
    hiddenStyle,
    isActive,
    disableUpMovement,
    disableDownMovement,
    columnPaddingX,
    columnWidth,
    isCurrentElementDragged,
    showDragBorder,
    isLastColumn,
    copied,
    mouseOver,
    mouseOut,
    click,
    copyBlock,
    deleteBlock,
    moveUp,
    moveDown,
    copyToClipboard,
  } = blockProperties(props);

  const isValidSrc = ref(false);

  const imgStyle = computed<StyleValue>(() => {
    return {
      border: "none",
      display: "block",
      outline: "none",
      "text-decoration": "none",
      height: "auto",
      "max-width": "100%",
      width: widthWithFluidOnMobile.value,
      "border-radius": props.block.attributes["border-radius"] || 0,
    };
  });

  const align = computed(() => {
    return props.block.attributes["align"]
      ? props.block.attributes["align"]
      : "center";
  });

  const widthWithFluidOnMobile = computed(() => {
    if (
      mjmlStore.isMobileFirstEnabled &&
      mjmlStore.isMobileView &&
      props.block.attributes["fluid-on-mobile"] === "true"
    ) {
      return "100%";
    }

    return width.value;
  });

  const width = computed(() => {
    if (props.block.attributes["width"]) {
      return parseInt(props.block.attributes["width"]) + "px";
    }
    // Calculate width
    // Get padding from sides
    const paddingParts = padding.value.split(" ");
    if (paddingParts.length == 2) {
      return (
        props.block.attributes["containerWidth"] -
        parseInt(paddingParts[1]) +
        "px"
      );
    } else if (paddingParts.length == 4) {
      return (
        props.block.attributes["containerWidth"] -
        parseInt(paddingParts[1]) -
        parseInt(paddingParts[3]) +
        "px"
      );
    }
    return "100%";
  });

  const padding = computed(() => {
    if (props.block.attributes["padding"]) {
      return props.block.attributes["padding"];
    }
    if (typeof props.block.attributes["padding-top"] != "undefined") {
      return (
        props.block.attributes["padding-top"] +
        "px " +
        props.block.attributes["padding-top"] +
        "px"
      );
    }
    return "10px 25px";
  });

  const src = computed(() => {
    return mjmlStore.getSpecificBlockAttr({
      sectionIndex: props.sectionIndex,
      columnIndex: props.columnIndex,
      blockIndex: props.blockIndex,
      attr: "src",
    });
  });

  const alt = computed(() => {
    return mjmlStore.getSpecificBlockAttr({
      sectionIndex: props.sectionIndex,
      columnIndex: props.columnIndex,
      blockIndex: props.blockIndex,
      attr: "alt",
    });
  });

  watch(src, (newValue) => {
    imageExists(newValue);
  });

  function imageExists(imageUrl: string) {
    return new Promise(() => {
      const image = new Image();

      image.onload = () => {
        if (image.width === 0) {
          isValidSrc.value = false;
        } else {
          isValidSrc.value = true;
        }
      };

      image.onerror = () => {
        isValidSrc.value = false;
      };
      image.src = imageUrl;
    });
  }

  onMounted(() => {
    imageExists(src.value);
  });
</script>

<style scoped lang="scss">
  .placeholder-container {
    color: rgb(109, 168, 255);
    background-color: rgb(231, 243, 255);
    text-decoration: none;
    text-align: center;
    line-height: 18px;
    display: flex;
    position: relative;
    border: rgba(109, 168, 255, 0.3) 1px solid;

    width: calc(100% - 2px);
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;

    font: var(
      --chip-font,
      var(--chip-font-weight, var(--font-normal))
        var(--chip-font-size, var(--font-xs)) / var(--chip-font-line-height, 1)
        var(--chip-font-family, var(--font-family-primary))
    );

    &__text {
      margin-top: 14px;
    }

    .img-2 {
      display: none;
    }

    &:hover {
      background-color: rgb(206, 231, 255) !important;
      color: rgb(72, 131, 255) !important;
      .img-1 {
        display: none;
      }

      .img-2 {
        display: inline-block;
      }
    }
  }
</style>
